import { datadogLogs } from '@datadog/browser-logs'

let didInit

const allowedStages = [
    'production',
    'staging',
]

const loggerInit = () => {
    if (!didInit) {
        datadogLogs.init({
            clientToken: process.env.DD_CLIENT_TOKEN,
            forwardErrorsToLogs: true,
        })

        didInit = true
    }
}

const allowExternalLogging = () => allowedStages.includes(process.env.STAGE)

const loggerWrapper = (func) => {
    if (allowExternalLogging()) {
        loggerInit()

        func()
    }
}

const logger = {
    debug: (message, messageContext) => loggerWrapper(
        () => datadogLogs.logger.debug(message, messageContext),
    ),
    info: (message, messageContext) => loggerWrapper(
        () => datadogLogs.logger.info(message, messageContext),
    ),
    warn: (message, messageContext) => loggerWrapper(
        () => datadogLogs.logger.warn(message, messageContext),
    ),
    error: (message, messageContext) => loggerWrapper(
        () => datadogLogs.logger.error(message, messageContext),
    ),
}

export default logger

export {
    loggerInit,
}
